import { IPricingRevaluationItemResultDTO } from "../../libs/coreapi-dto/dirs/pricingInvoice";
import { IPricingAdpricePercentResponse, IPricingRevaluationItemDTO } from "../../libs/coreapi-dto/dirs/pricingRevaluation";
import CoreApiService from "../../system/api/coreApiService";

export class PricingRevaluationDataProvider {

    private _coreApiService: CoreApiService

    constructor(coreApiService: CoreApiService) {
        this._coreApiService = coreApiService
    }

    calculateItem(idGlobal: string, body: IPricingRevaluationItemDTO, 
        callback?: (data: IPricingRevaluationItemResultDTO) => void, 
        signal?: AbortSignal | null, 
        errCallback?: (err: string) => void) {

        this._coreApiService.pricingRevaluationRequest
            .then(r =>
                r.sendCalculateItemRequest(idGlobal, body, (e) => {
                    if (e.respType === 'isCompleted') {
                        callback?.(e.data);
                    } else {
                        errCallback?.(e.message.title as string);
                    }
                },
                signal)
            );
    }

    calculateAdpricePercent(idModel: string, body: IPricingRevaluationItemDTO, 
        callback?: (data: IPricingAdpricePercentResponse) => void, 
        signal?: AbortSignal | null, 
        errCallback?: (err: string) => void) {

        this._coreApiService.pricingRevaluationRequest
            .then(r =>
                r.sendCalculateAdpricePercentRequest(idModel, body, (e) => {
                    if (e.respType === 'isCompleted') {
                        callback?.(e.data);
                    } else {
                        errCallback?.(e.message.title as string);
                    }
                },
                signal)
            );
    }

    calculateBatch(idGlobal: string, body: IPricingRevaluationItemDTO[], 
        callback?: (data: IPricingRevaluationItemResultDTO[]) => void, 
        signal?: AbortSignal | null, 
        errCallback?: (err: string) => void) {

        this._coreApiService.pricingRevaluationRequest
            .then(r =>
                r.sendCalculateBatchRequest(idGlobal, body, (e) => {
                    if (e.respType === 'isCompleted') {
                        callback?.(e.data);
                    } else {
                        errCallback?.(e.message.title as string);
                    }
                },
                signal)
            );
    }
}